export default __webpack_public_path__ + "static/media/product3.82334f56.jpg";